import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useAppDispatch from '../../hooks/useAppDispatch';
import { setRequestedUrl } from '../../store/slices/login';

const useLoginRedirectionParams = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const requestedUrl = searchParams.get('r');

  useEffect(() => {
    if (requestedUrl) {
      dispatch(
        setRequestedUrl({
          requestedUrl,
        }),
      );
    }
  }, [requestedUrl]);
};

export default useLoginRedirectionParams;
